import IconWrapper from './iconWrapper.component'
import { IWebMenu } from '../../../interfaces/webMenu'
import Link from 'next/link'
import { urlObjectFactoryForWebmenus } from '../../../utils/webmenus'
import { useAppContext } from '../../../context/siteMapContext'

interface ISimpleCardProps {
  webmenu: IWebMenu
}

const SimpleCard: React.FC<ISimpleCardProps> = ({ webmenu }) => {
  const { highContrastOn } = useAppContext();
  const { name_HU, backgroundColor, iconColor, fontColor, iconUrl } = webmenu
  const { urlObject, asPath } = urlObjectFactoryForWebmenus(webmenu)
  return (
    <>
      <Link href={webmenu.link ?? urlObject} as={webmenu.link ? undefined : asPath} scroll={false} shallow >
        <a
          style={{
            backgroundColor: highContrastOn ? 'white' : backgroundColor,
          }}
          target={webmenu.openNewTab ? '_blank' : '_self'}
          className={`z-1 col-span-2 p-0 xl:p-6 rounded-[2rem] 2xl:col-span-3 h-card`}
        >
          <IconWrapper
            name={name_HU}
            iconColor={iconColor}
            fontColor={fontColor}
            iconUrl={iconUrl}
          />
        </a>
      </Link>
    </>
  )
}

export default SimpleCard
